<template>
  <categories-index />
</template>

<script>
import CategoriesIndex from '../../components/categories/Index'

export default {
  name: 'CategoriesPageIndex',
  components: { CategoriesIndex }
}
</script>

<style scoped>
  /* Always export scoped styles to not break the app */
</style>
